import React from 'react';
import './Icon.css';

/**
 * Icon component using Material Icons
 * @param {string} name - Material icon name (e.g., 'restaurant', 'home', 'person')
 * @param {string} size - Size: 'small', 'medium', 'large' (default: 'medium')
 * @param {string} className - Additional CSS classes
 */
function Icon({ name, size = 'medium', className = '' }) {
  return <span className={`material-icons icon-${size} ${className}`}>{name}</span>;
}

export default Icon;
